import { useEffect, useState } from 'react';
import { fetchEnergySummary } from '../services/unit.api';
import { normalizeUnitEnergyForChart } from '../utils/unitDetails.helpers';

export function useUnitEnergySummary({ unitName, range }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!unitName) {
      setData([]);
      return;
    }

    let alive = true;
    setLoading(true);

    (async () => {
      try {
        const params = { train: unitName };
        if (range?.start && range?.end) {
          params.from = range.start;
          params.to = range.end;
        }
        const rows = await fetchEnergySummary(params);
        if (!alive) return;
        setData(normalizeUnitEnergyForChart(rows));
      } catch {
        if (!alive) return;
        setData([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => { alive = false; };
  }, [unitName, range?.start, range?.end]);

  return { data, loading };
}
